module.exports = "<template> <sio-translatable field.bind=field value.bind=field.value></sio-translatable> </template> ";